import angular from "angular";

import SubscriptionService from "./SubscriptionService";
import Assert from "tbAssert";

import OfficeDataServiceModule from "../OfficeDataService";

const mOfficeDataSvc = new WeakMap();
const mQSvc = new WeakMap();
const mLogSvc = new WeakMap();

class OfficeSubscriptionService extends SubscriptionService {
    constructor($q, $log, OfficeData) {
        super();

        Assert.StrictAssert($q != null, "Assertion Failure: Missing Q Service Dependency");
        Assert.StrictAssert($log != null, "Assertion Failure: Missing Log Service Dependency");
        Assert.StrictAssert(OfficeData != null, "Assertion Failure: Missing Office Data Service Dependency");

        mQSvc.set(this, $q);
        mLogSvc.set(this, $log);
        mOfficeDataSvc.set(this, OfficeData);
    }

    getTarget(officeTargetId) {
        let officeRetrievalPromise =
            mOfficeDataSvc.get(this)
                .getCore({officeId: officeTargetId})
                .$promise
                .then(
                    (retrievedOffice) => retrievedOffice.result,
                    (errorResponse) => mQSvc.get(this).reject(errorResponse)
                );

        return officeRetrievalPromise;
    }

    getTargetBatch(officeTargetIds) {
        let officeRetrievalPromises = officeTargetIds.map((tgtId) => this.getTarget(tgtId));

        return mQSvc.get(this).all(officeRetrievalPromises);
    }

    addSubscription(recipientId, officeTargetId) {
        let subAddPromise = mOfficeDataSvc.get(this).addSubscription({
                officeId: officeTargetId,
                recipientId: recipientId
            })
            .$promise
            .then(
                (updatedOfficeResource) => {
                    let updatedOffice = updatedOfficeResource.result;
                    let selectedSubs = updatedOffice.officeSubscribers;
                    let numSubs = selectedSubs.length;
                    let foundSubscriber = false;
                    for (let subIdx = 0; (!foundSubscriber) && (subIdx < numSubs); subIdx++) {
                        if (selectedSubs[subIdx].recipientId === recipientId) {
                            foundSubscriber = true;
                        }
                    }
                    if (!foundSubscriber) {
                        return mQSvc.get(this).reject("Failed to add subscription.");
                    }
                    else {
                        return true;
                    }
                },
                (errorResponse) => {
                    return mQSvc.get(this).reject(errorResponse);
                }
            );

        return subAddPromise;
    }

    removeSubscription(recipientId, officeTargetId) {
        let subDelPromise = mOfficeDataSvc.get(this).removeSubscription({
                officeId: officeTargetId,
                recipientId: recipientId
            })
            .$promise
            .then(
                (updatedOfficeResource) => {
                    let updatedOffice = updatedOfficeResource.result;
                    let selectedSubs = updatedOffice.officeSubscribers;
                    let numSubs = selectedSubs.length;
                    let foundSubscriber = false;
                    for (let subIdx = 0; (!foundSubscriber) && (subIdx < numSubs); subIdx++) {
                        if (selectedSubs[subIdx].recipientId === recipientId) {
                            foundSubscriber = true;
                        }
                    }
                    if (!foundSubscriber) {
                        return true;
                    }
                    else {
                        return mQSvc.get(this).reject("Failed to remove subscription.");
                    }
                },
                (errorResponse) => {
                    return mQSvc.get(this).reject(errorResponse);
                }
            );

        return subDelPromise;
    }
}

OfficeSubscriptionService.$inject = [ "$q", "$log", "OfficeData" ];

export default angular
    .module("trackerbase-app.services.subscription-data-adapters.office-subscription-service",[
        OfficeDataServiceModule
    ])
    .service("OfficeSubscriptionData", OfficeSubscriptionService)
    .name;




//////////////////
// WEBPACK FOOTER
// ./src/services/subscription-data-services/OfficeSubscriptionService.js
// module id = XOMH
// module chunks = 1